<template>
	<div
		class="show-more-btn text-center absolute bottom-0 left-0 right-0 h-24 py-4 lg:py-6 bg-gradient-to-t from-white flex flex-col justify-end to-transparent"
	>
		<button
			@click="click"
			:class="[
				'text-sm font-medium px-4 py-2 rounded-lg max-w-[140px] mx-auto',
				props.alternative
					? 'bg-white text-blue-300 border-2 border-gradient-to-r from-[#50B5FF] to-[#BE55FF]'
					: props.variant === 'primary'
						? 'bg-yellow-500 text-black'
						: 'bg-blue-300 text-white'
			]"
		>
			{{ props.isExpanded ? "Show Less" : "Show More..." }}
		</button>
	</div>
</template>

<script setup>
const emit = defineEmits(["click"]);

const click = () => {
	emit("click");
};

const props = defineProps({
	alternative: {
		type: Boolean,
		default: false
	},
	isExpanded: {
		type: Boolean,
		default: false
	},
	variant: {
		type: String,
		default: "default" // "default" (blue) | "primary" (brand yellow)
	}
});
</script>

<style scoped>
.border-gradient-to-r {
	background:
		linear-gradient(white, white) padding-box,
		linear-gradient(to right, #50b5ff, #be55ff) border-box;
	border: 2px solid transparent;
}
</style>
